export default "__VITE_ASSET__DOEcKFfg__"